<script setup lang="ts">
import type { ResourceRef } from '@/lib/resource-links'
import { canonicalResourceType, resourceRefLabel } from '@/lib/resource-links'
import { Badge } from '@kyoto2/components/ui/badge'

defineProps<{ resourceRef: ResourceRef }>()
</script>

<template>
  <div class="p-2 text-xs space-y-1 max-w-[260px] min-w-0">
    <Badge variant="outline" class="text-[10px]">{{ canonicalResourceType(resourceRef.type).replace(/_/g, ' ') }}</Badge>
    <p class="font-medium break-words">{{ resourceRefLabel(resourceRef) }}</p>
  </div>
</template>
